import { useEffect, useState } from "react";
import { Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { Title, usePermissions } from "react-admin";
import { Navigate } from "react-router-dom";

import { adminApi } from "../dataProvider";

type Stats = {
  users_total: number;
  kyc_green: number;
  wallets_total: number;
  primary_wallet_address: string | null;
  total_balance_usdt: string;
  total_balance_trx: string;
  transactions_total: number;
  transactions_confirmed: number;
  usdt_sent_volume: string;
};

const Tile = ({ label, value, subtitle }: { label: string; value: string | number; subtitle?: string }) => (
  <Card>
    <CardContent>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="h5" sx={{ mt: 1, fontWeight: 600 }}>{value}</Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
    </CardContent>
  </Card>
);

export function Dashboard() {
  const { isLoading, permissions } = usePermissions();
  const [s, setS] = useState<Stats | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const isAdmin = permissions === "admin";

  useEffect(() => {
    if (isLoading || !isAdmin) return;
    adminApi<Stats>("/admin/dashboard").then(setS).catch((e) => setErr(String(e)));
  }, [isLoading, isAdmin]);

  if (!isLoading && !isAdmin) return <Navigate to="/orders" replace />;

  return (
    <>
      <Title title="Дашборд" />
      <Stack spacing={2} sx={{ p: 2 }}>
        <Typography variant="h5">Сводка</Typography>
        {err && <Typography color="error">{err}</Typography>}
        {!s && !err && <Typography color="text.secondary">Загрузка…</Typography>}
        {s && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}><Tile label="Пользователей" value={s.users_total} /></Grid>
            <Grid item xs={12} sm={6} md={3}><Tile label="KYC пройден" value={s.kyc_green} /></Grid>
            <Grid item xs={12} sm={6} md={3}><Tile label="Кошельков" value={s.wallets_total} subtitle={s.primary_wallet_address ?? "primary не назначен"} /></Grid>
            <Grid item xs={12} sm={6} md={3}><Tile label="USDT (всего)" value={s.total_balance_usdt} subtitle={`TRX: ${s.total_balance_trx}`} /></Grid>
            <Grid item xs={12} sm={6} md={3}><Tile label="Транзакций" value={s.transactions_total} subtitle={`confirmed: ${s.transactions_confirmed}`} /></Grid>
            <Grid item xs={12} sm={6} md={3}><Tile label="Отправлено USDT" value={s.usdt_sent_volume} /></Grid>
          </Grid>
        )}
      </Stack>
    </>
  );
}
